import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import '../static/css/fix.css'
import '../static/css/effect.css'
import '../static/css/font.css'
import '../static/css/basic.css'
import '../static/css/style.css'
// import '../static/css/images.css'
import Items from './components/items'
import Alert from './components/alert'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(Items)
Vue.use(Alert)
/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js